import { Nullable } from "@/general/custom-types/CustomTypes";

export class MeterFormModel {
  id: Nullable<number>;
  dataLogger: Nullable<number>;
  model: Nullable<number>;
  location: Nullable<number>;
  meterNumber: Nullable<number>;
  description: Nullable<string>;

  constructor(
    id?: Nullable<number>,
    model?: Nullable<number>,
    location?: Nullable<number>,
    meterNumber?: Nullable<number>,
    dataLogger?: Nullable<number>,
    description?: Nullable<string>
  ) {
    this.id = id;
    this.model = model;
    this.location = location;
    this.meterNumber = meterNumber;
    this.dataLogger = dataLogger;
    this.description = description;
  }
}
